import { takeEvery, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  IBenefitInvestigationLatest,
  BenefitInvestigationLatestMap,
} from 'interfaces/redux/ITherapyBenefitsInvestigationLatest';
import { mapValues } from 'lodash';
import { change } from 'redux-form';
import {
  BI_AUTO_SAVE,
  BULK_TASKS_UPDATED,
  FETCH_BI_INFO,
  NOTIFY_SUCCESS,
  REFRESH_BI_HISTORY,
  SELECTED_PATIENT_ID,
  SET_RECENT_BI_EXECUTION,
  UPDATE_BY_THERAPY_ID,
} from '../constants';
import { BenefitsInvestigationService } from '../services/utils/benefits-investigation-service';
import { BenefitInvestigationLatestActionType } from '../actions/action-therapy-benefits-investigation-latest';
import { IState } from '../interfaces/redux/IState';

const service = new BenefitsInvestigationService();

export const SET_FC_DISPENSE_QTY_FROM_BI = 'SET_FC_DISPENSE_QTY_FROM_BI';

export function* getByPatientId(action: {
  type: string;
  payload: number;
}): Generator<any, any, any> {
  const patientId = Number(action.payload);
  // If action.payload it's null its parsed as 0 by Number , so checking first if patientId it's truthy
  if (
    patientId !== 0 &&
    !Number.isNaN(patientId) &&
    (window as any)?.FEATURES?.benefits_investigations === true
  ) {
    try {
      const response: IBenefitInvestigationLatest[] = yield call(
        service.getLatestTherapyBenefitInvestigationsByPatientId,
        patientId,
      );

      // Mapping to {therapyId: object} for fast lookup by therapyId
      const biMapByTherapyId: BenefitInvestigationLatestMap = response.reduce(
        (map: any, biResponse: IBenefitInvestigationLatest) => {
          map[biResponse.therapyId] = biResponse;
          return map;
        },
        {},
      );

      yield put({
        type: BenefitInvestigationLatestActionType.GetByPatientIdSuccess,
        payload: biMapByTherapyId,
      });
    } catch (error) {
      yield put({
        type: BenefitInvestigationLatestActionType.GetByPatientIdFailed,
      });
    }
  }
}

function* fetchLatestBenefitsInvestigation(action: { type: string; payload: any }) {
  const state: IState = yield select();
  const { selectedPatientId } = state;
  const patientId = selectedPatientId;
  if (
    patientId !== 0 &&
    !Number.isNaN(patientId) &&
    (window as any)?.FEATURES?.benefits_investigations === true
  ) {
    try {
      const response: IBenefitInvestigationLatest[] = yield call(
        service.getLatestTherapyBenefitInvestigationsByPatientId,
        patientId,
      );

      // Mapping to {therapyId: object} for fast lookup by therapyId
      const biMapByTherapyId: BenefitInvestigationLatestMap = response.reduce(
        (map: any, biResponse: IBenefitInvestigationLatest) => {
          map[biResponse.therapyId] = biResponse;
          return map;
        },
        {},
      );

      yield put({
        type: BenefitInvestigationLatestActionType.GetByPatientIdSuccess,
        payload: biMapByTherapyId,
      });
    } catch (error) {
      yield put({
        type: BenefitInvestigationLatestActionType.GetByPatientIdFailed,
      });
    }
  }
}
export function* setDipenseQtyFromBI(action: { type: string; payload: any }) {
  const { quantity } = action.payload;
  if (quantity) {
    const quantityEntries: { ['key']: string } = yield select(
      state => state.form.FILL_COORDINATION_TRANSITION?.values?.dispense_qty,
    );
    const dispenseQtys = mapValues(quantityEntries, () => quantity);
    yield put(change('FILL_COORDINATION_TRANSITION', 'dispense_qty', dispenseQtys));
  }
}

function* autoSave(action: { type: string; payload: any }) {
  const { responseData, patientId } = action.payload;
  if (responseData.internalId) {
    const result: IBenefitInvestigationLatest = yield call(
      service.updateBenefitsInvestigationSaved,
      patientId,
      responseData.internalId,
      true,
    );
    if (result) {
      yield put({
        type: BenefitInvestigationLatestActionType.UpdateByTherapyId,
        payload: result,
      });
      yield put({
        type: NOTIFY_SUCCESS,
        payload: 'Benefits investigation successfully auto saved',
      });
    }
  }
}

function* setRecentBiExecution(action: { type: string; payload: any }) {
  yield put({
    type: SET_RECENT_BI_EXECUTION,
    payload: action.payload,
  });
}

export function* watcherTherapyBenefitsInvestigationSaga() {
  // yield takeLatest(BULK_TASKS_UPDATED, fetchLatestBenefitsInvestigation);
  yield takeLatest(REFRESH_BI_HISTORY, fetchLatestBenefitsInvestigation);
  yield takeLatest(SET_FC_DISPENSE_QTY_FROM_BI, setDipenseQtyFromBI);
  yield takeLatest([FETCH_BI_INFO], getByPatientId);
  yield takeLatest(BI_AUTO_SAVE, autoSave);
  yield takeLatest(UPDATE_BY_THERAPY_ID, setRecentBiExecution);
}
